function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "",
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { _escape } from "./lib/_escape";
import { Base } from "./Base";
import { join, pipe } from "@fxts/core";
import { _htmlEscapeJsonString } from "./lib/_htmlEscapeJsonString";
import { rune } from "./rune";
export class VirtualView extends Base {
    get data() {
        return this._data;
    }
    set data(data) {
        throw TypeError("'data' property is readonly.");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ template(data) {
        return html(_templateObject());
    }
    _matchStartTag(html) {
        const matched = html.match(/^\s*<(\w+|!)[^>]*>/);
        return {
            startTag: matched[0],
            startTagName: matched[1]
        };
    }
    _addRuneAttrs(html, isSSR) {
        if (this.isLayout) return html;
        const { startTag, startTagName } = this._matchStartTag(html);
        const runeDataset = 'data-rune="'.concat(this, '" data-rune-parent="').concat(this.parentView, '"');
        const className = this.className ? "".concat(this, " ").concat(this.className) : "".concat(this);
        html = startTag.includes('class="') ? html.replace('class="', "".concat(runeDataset, ' class="').concat(className, " ")) : startTag.includes("class='") ? html.replace("class='", "".concat(runeDataset, " class='").concat(className, " ")) : html.replace("<".concat(startTagName), "<".concat(startTagName, " ").concat(runeDataset, ' class="').concat(className, '"'));
        return isSSR ? "".concat(html, '<script class="__RUNE_DATA__ ').concat(this, '" type="application/json" data-rune-base-name="').concat(this._base_name, '">').concat(_htmlEscapeJsonString(JSON.stringify({
            data: this.data,
            args: this._args,
            sharedData: rune.getSharedData(this),
            key: this.key,
            name: this.constructor.name
        })), "</script>") : html;
    }
    _currentInnerHtml() {
        const html = this._currentHtml;
        const { startTag, startTagName } = this._matchStartTag(html);
        return html.replace(startTag, "").slice(0, -(startTagName.length + 3));
    }
    _resetCurrentHtml(currentHtml, isSSR) {
        this.renderCount++;
        this._currentHtml = this._addRuneAttrs(currentHtml.trim(), isSSR);
        return this;
    }
    _makeHtml(isSSR) {
        if (this.data === null) throw new TypeError("'this.data' is not assigned.");
        this.subViewsFromTemplate = [];
        return this._resetCurrentHtml(html(_templateObject1(), this.template(this.data)).make(this), isSSR);
    }
    ready() {}
    toHtml(isSSR) {
        if (this.renderCount === 0) this.ready();
        return this._makeHtml(isSSR)._currentHtml;
    }
    toHtmlSSR() {
        return html.preventEscape(this.toHtml(true));
    }
    constructor(data, ...args){
        super();
        _define_property(this, "key", "");
        _define_property(this, "_base_name", "VirtualView");
        _define_property(this, "_data", void 0);
        _define_property(this, "_args", void 0);
        _define_property(this, "parentView", null);
        _define_property(this, "subViewsFromTemplate", []);
        _define_property(this, "isLayout", false);
        _define_property(this, "renderCount", 0);
        _define_property(this, "_currentHtml", null);
        _define_property(this, "className", "");
        this._data = data;
        this._args = args;
    }
}
export function html(templateStrs) {
    for(var _len = arguments.length, templateVals = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        templateVals[_key - 1] = arguments[_key];
    }
    return new Html(templateStrs, templateVals);
}
html.preventEscape = (htmlStr)=>new UnsafeHtml(htmlStr);
export class Html {
    make(virtualView) {
        return pipe(this._make(virtualView, (view)=>view.toHtml(), (html, view)=>html.make(view)), join(""));
    }
    *_make(virtualView, toHtml, make) {
        const end = this._templateStrs.length - 1;
        for(let i = 0; i < end; i++){
            yield this._templateStrs[i];
            for (const templateVal of this._wrapArray(this._templateVals[i])){
                yield this._isSubView(templateVal, virtualView) ? toHtml(this._addSubViewsFromTemplate(templateVal, virtualView)) : templateVal instanceof Html ? make(templateVal, virtualView) : templateVal instanceof UnsafeHtml ? templateVal.toString() : _escape(templateVal);
            }
        }
        yield this._templateStrs[end];
    }
    _wrapArray(templateVals) {
        return Array.isArray(templateVals) ? templateVals : [
            templateVals
        ];
    }
    _isSubView(templateVal, virtualView) {
        return virtualView !== templateVal && virtualView.parentView !== templateVal && templateVal instanceof VirtualView;
    }
    _addSubViewsFromTemplate(subView, virtualView) {
        subView.parentView = virtualView;
        virtualView.subViewsFromTemplate.push(subView);
        return subView;
    }
    constructor(templateStrs, templateVals){
        _define_property(this, "_templateStrs", void 0);
        _define_property(this, "_templateVals", void 0);
        this._templateStrs = templateStrs;
        this._templateVals = templateVals;
    }
}
export class UnsafeHtml {
    toString() {
        return this._htmlStr;
    }
    constructor(_htmlStr){
        _define_property(this, "_htmlStr", void 0);
        this._htmlStr = _htmlStr;
    }
}
